import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import artigos from '../data';

export default function Acervo({ user, onLogout }) {
  const anos    = Object.keys(artigos).map(Number).sort((a, b) => b - a);
  const total   = Object.values(artigos).reduce((s, arr) => s + arr.length, 0);
  const [abertos, setAbertos] = useState({ [anos[0]]: true });
  const navigate = useNavigate();

  function abrirPdf(artigo) {
    // Codifica o caminho do arquivo na URL
    const path = artigo.drive.replace(/^\/pdfs\//, '');
    navigate('/pdf/' + encodeURIComponent(path));
  }

  return (
    <div className="app">
      <header className="topbar">
        <div className="topbar-brand">
          <div className="brand-icon">
            <svg viewBox="0 0 14 14"><path d="M2 10 L7 4 L12 10"/><path d="M4.5 8 L9.5 8"/></svg>
          </div>
          <span className="brand-name">Revista Ordem Pública</span>
          <span className="brand-sub">ACORS · PMSC</span>
        </div>
        <div className="topbar-right">
          <span className="topbar-user">{user.name}</span>
          <button className="btn-logout" onClick={onLogout}>Sair</button>
        </div>
      </header>

      <main className="content">
        <div className="page-header">
          <h1>Acervo</h1>
          <p>Publicações da Revista Ordem Pública</p>
          <div className="stats-row">
            <span className="stat-chip"><b>{total}</b> artigos</span>
            <span className="stat-chip"><b>{anos.length}</b> edições</span>
            <span className="stat-chip"><b>{anos[anos.length - 1]}–{anos[0]}</b> período</span>
          </div>
        </div>

        {anos.map(ano => {
          const lista  = artigos[ano];
          const isOpen = !!abertos[ano];
          return (
            <div className="year-block" key={ano}>
              <button className="year-header" onClick={() => setAbertos(p => ({ ...p, [ano]: !p[ano] }))}>
                <span className={`chevron-wrap${isOpen ? ' open' : ''}`}>
                  <svg viewBox="0 0 8 8"><polyline points="2,2 6,4 2,6"/></svg>
                </span>
                <span className="year-num">{ano}</span>
                <span className="year-count">{lista.length} artigo{lista.length !== 1 ? 's' : ''}</span>
                <span className="year-sep" />
              </button>

              {isOpen && (
                <div className="articles-list">
                  {lista.map((artigo, i) => {
                    const fileId = artigo.drive.replace(/^\/pdfs\//, '');
                    const dlUrl  = `/pdf.php?file=${encodeURIComponent(fileId)}&dl=1`;
                    return (
                      <div className="article-item" key={i}>
                        <div className="article-info">
                          <div className="article-title">{artigo.titulo}</div>
                          <div className="article-meta">
                            {artigo.autores}{artigo.paginas ? ` · p. ${artigo.paginas}` : ''}
                          </div>
                        </div>
                        <div className="article-actions">
                          <button className="btn-ler" onClick={() => abrirPdf(artigo)}>Ler</button>
                          <a className="btn-dl" href={dlUrl} target="_blank" rel="noreferrer" download title="Baixar PDF">
                            <svg viewBox="0 0 12 12">
                              <path d="M6 2 L6 8"/><path d="M3 6 L6 9 L9 6"/><path d="M2 11 L10 11"/>
                            </svg>
                          </a>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </main>
    </div>
  );
}
